import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Form, Row, Spinner, Table } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { commonservices } from "../services/CommonServices";
import { useDispatch, useSelector } from "react-redux";
import {
    SubscribersContactGetByPrimaryKey,
    SubscribersContactGetList,
    SubscribersContactResendVerificationMail,
    SubscribersContactSave,
} from "../services/ReduxTookit/Slice/SubscribersContactRedux";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import Nodata from "../component/common-component/Nodata";
import Loader, { LoaderType } from "../component/common-component/Loader";
import profilepic from "../assets/images/dummy-profile-pic.jpg";
import { toast } from "react-toastify";
import {
    BecomeClient,
    BecomeDeveloper,
} from "../services/ReduxTookit/Slice/SubscribersRedux";
import { GetByPrimarykey } from "../services/ReduxTookit/Slice/UserRedux";
import infoIcon from "../assets/images/infobtnblue.svg";
import MainpageLoader from "../component/common-component/Loaders/MainpageLoader";

const WorkFlowPassModal = (props) => {
    const DevRoute = window.location.href.includes(
        `${process.env.REACT_APP_DEV}`
    );
    const RoleList = useSelector(
        (state) => state?.roleredux?.RoleGetListData?.data?.data?.data?.dataList1
    );

    const [ContactList, setContactList] = useState([]);

    const [selectedContact, setSelectedContact] = useState([]);

    const [errorShow, setErrorShow] = useState([]);

    const [Loading, setLoading] = useState(false);

    const [ContactLoader, setContactLoader] = useState(false);

    const dispatch = useDispatch();
    const [input, setInput] = useState({
        subscriberscontactid: 0,
        firstname: "",
        lastname: "",
        email: "",
        contactno: "",
        address: "",
        city: "",
        state: "",
        country: "",
        zipcode: "",
        photofile: "",
        roleid: "",
        developerroleid: 7,
        errors: {
            subscriberscontactid: "",
            firstname: "",
            lastname: "",
            email: "",
            contactno: "",
            address: "",
            city: "",
            state: "",
            country: "",
            zipcode: "",
            photofile: "",
            roleid: "",
            ValidationRules: [
                {
                    FieldName: "firstname",
                    ValidationType: "required",
                    ValidationMessage: "This Field is a required field",
                },
                {
                    FieldName: "lastname",
                    ValidationType: "required",
                    ValidationMessage: "This Field is a required field",
                },
                {
                    FieldName: "email",
                    ValidationType: "required",
                    ValidationMessage: "This Field is a required field",
                },
                {
                    FieldName: "email",
                    ValidationType: "email",
                    ValidationMessage: "Invalid email format",
                },
                {
                    FieldName: "contactno",
                    ValidationType: "required",
                    ValidationMessage: "This Field is a required field",
                },
                {
                    FieldName: "roleid",
                    ValidationType: DevRoute ? "" : "required",
                    ValidationMessage: "This Field is a required field",
                },
            ],
        },
    });
    async function getContactList() {
        setContactLoader(true);
        let body = {
            contactname: "",
            email: "",
            contactno: "",
        };
        dispatch(SubscribersContactGetList(body))
            .then((response) => {
                if (response?.payload?.isValidate) {
                    setContactList(response?.payload?.data?.data);
                }
                if (!response?.payload?.isValidate) {
                    setContactList([]);
                }
            })
            .finally(() => {
                setContactLoader(false);
            });
    }
    useEffect(() => {
        getContactList();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        props.callBackFunction(selectedContact)
        //setLoading(true);
        //if (DevRoute) {
        //    checkBecomeClient();
        //} else {
        //    checkBecomeDeveloper();
        //}
    };

    const fnInputChange = (e, id) => {
        let a = [...selectedContact];
        for (let i = 0; i < a.length; i++) {
            if (a[i].userid === id) {
                a[i].roleid = e?.target?.value ? parseInt(e?.target?.value) : "";
            }
        }
        setSelectedContact(a);

        const updatedIds = errorShow.filter((ids) => ids !== id);

        setErrorShow(updatedIds);
    };

    //const checkBecomeDeveloper = async () => {
    //    dispatch(BecomeDeveloper(selectedContact))?.then((response) => {
    //        if (response?.payload?.isValidate) {
    //            dispatch(GetByPrimarykey({}));
    //        }
    //        if (!response?.payload?.isValidate) {
    //        }
    //        setLoading(false);
    //        props.onHide();
    //    });
    //};

    //const checkBecomeClient = async () => {
    //    let a = selectedContact
    //        ?.filter((item) => item?.roleid === "")
    //        .map((item) => item?.userid);

    //    if (a?.length > 0) {
    //        setErrorShow(a);
    //        setLoading(false);
    //    } else {
    //        dispatch(BecomeClient(selectedContact))?.then((response) => {
    //            if (response?.payload?.isValidate) {
    //                dispatch(GetByPrimarykey({}));
    //            }
    //            if (!response?.payload?.isValidate) {
    //            }
    //            setLoading(false);
    //            props.onHide();
    //        });
    //    }
    //};

    const GetByDisabled = (id) => {
        const ab = selectedContact?.some((item) => item?.userid === id);
        return !ab;
    };

    const AddData = (e) => {
       
        const maxAllowed = 100;//maxSelections[props.type];
        if (e?.target?.checked) {
            if (selectedContact?.length >= maxAllowed) {
                toast.error(
                    `You can only select up to ${maxAllowed} contacts for ${maxAllowed} type.`
                );
                e.target.checked = false;
                return;
            }

            let selectedContactItem = ContactList?.find(
                (item) => item?.subscriberscontactid === parseInt(e?.target?.value)
            );

            if (selectedContactItem) {
                const { userid, email, contactname, subscriberscontactid } =
                    selectedContactItem;
                const newContact = {
                    userid,
                    email,
                    name: contactname,
                    roleid: DevRoute ? "" : 7,
                    subscriberscontactid,
                };
                setSelectedContact((prev) => [...(prev || []), newContact]);
            }
        } else {
            let updatedContacts = selectedContact?.filter(
                (item) => item?.subscriberscontactid !== parseInt(e?.target?.value)
            );

            setSelectedContact(updatedContacts);
        }
    };

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="pass-contactmodel"
        >
            {Loading && <MainpageLoader />}
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">Contact</Modal.Title>
            </Modal.Header>
            <Form
                onSubmit={(e) => {
                    handleSubmit(e);
                }}
            >
                <Modal.Body>
                    <div className="main-page-content">
                        <Container style={{ padding: "0px" }}>
                            <div className="table-wrapper-main" style={{ border: "none" }}>
                                <Table responsive>
                                    <thead>
                                        <tr style={{ border: "none" }}>
                                            {/* <th className="sticky-workflow"></th> */}
                                            <th className="width200 sticky-workflow">Name</th>
                                            <th className="width200">Email</th>
                                            <th className="width150">Phone Number</th>
                                            <th className="width100">Machines</th>
                                            <th className="width100">Workflow</th>
                                            <th className="width100">Role</th>
                                            <th className="width200">Role-Right</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ContactLoader ? (
                                            <Loader type={LoaderType.TableRow} count={3} nooftd={7} />
                                        ) : (
                                            <>
                                                {ContactList?.length > 0 ? (
                                                    ContactList?.map((item, index) => (
                                                        <>
                                                            {DevRoute && item?.developerrole ? (
                                                                <tr key={index}>
                                                                    <td className="theme-color-text fw600 sticky-workflow">
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <input
                                                                                type="checkbox"
                                                                                id={item?.subscriberscontactid}
                                                                                value={item?.subscriberscontactid}
                                                                                onClick={(e) => AddData(e)}
                                                                                style={{ cursor: "pointer" }}
                                                                            />
                                                                            <div>
                                                                                {" "}
                                                                                <img
                                                                                    className="small-profile-pic"
                                                                                    src={
                                                                                        item?.photourl
                                                                                            ? item?.photourl
                                                                                            : profilepic
                                                                                    }
                                                                                    alt="profilepic"
                                                                                    onError={({ currentTarget }) => {
                                                                                        currentTarget.onerror = null;
                                                                                        currentTarget.src = profilepic;
                                                                                    }}
                                                                                />
                                                                                <span className="ms-2">
                                                                                    {item?.contactname}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td>{item?.email}</td>
                                                                    <td> {item?.contactno}</td>
                                                                    <td>{item?.machine}</td>
                                                                    <td>{item?.workflow}</td>
                                                                    <td>{item?.developerrole}</td>
                                                                    <td>
                                                                        <div className="position-relative">
                                                                            <Form.Select
                                                                                className={
                                                                                    errorShow?.includes(item?.userid)
                                                                                        ? "common-select-red contact-dropdown-size m-"
                                                                                        : "common-select contact-dropdown-size m-0"
                                                                                }
                                                                                // value={input.roleid}
                                                                                disabled={GetByDisabled(item?.userid)}
                                                                                onChange={(e) => {
                                                                                    fnInputChange(e, item?.userid);
                                                                                }}
                                                                                isInvalid={input?.errors?.roleid}
                                                                            >
                                                                                <option value="">Select Role</option>
                                                                                {RoleList?.map((item) => {
                                                                                    return (
                                                                                        <option value={item?.roleid}>
                                                                                            {item?.rolename}
                                                                                        </option>
                                                                                    );
                                                                                })}
                                                                            </Form.Select>
                                                                            {errorShow?.includes(item?.userid) && (
                                                                                <span className="error-message-icon">
                                                                                    <img
                                                                                        src={infoIcon}
                                                                                        alt="infoIcon"
                                                                                        title="Role is required"
                                                                                    />
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                <></>
                                                            )}
                                                            {!DevRoute && item?.workflowrole ? (
                                                                <tr key={index}>
                                                                    <td className="theme-color-text fw600 sticky-workflow">
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <input
                                                                                type="checkbox"
                                                                                id={item?.subscriberscontactid}
                                                                                value={item?.subscriberscontactid}
                                                                                onClick={(e) => AddData(e)}
                                                                                style={{ cursor: "pointer" }}
                                                                            />
                                                                            <div>
                                                                                {" "}
                                                                                <img
                                                                                    className="small-profile-pic"
                                                                                    src={
                                                                                        item?.photourl
                                                                                            ? item?.photourl
                                                                                            : profilepic
                                                                                    }
                                                                                    alt="profilepic"
                                                                                    onError={({ currentTarget }) => {
                                                                                        currentTarget.onerror = null;
                                                                                        currentTarget.src = profilepic;
                                                                                    }}
                                                                                />
                                                                                <span className="ms-2">
                                                                                    {item?.contactname}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td>{item?.email}</td>
                                                                    <td> {item?.contactno}</td>
                                                                    <td>{item?.machine}</td>
                                                                    <td>{item?.workflow}</td>
                                                                    <td>{item?.workflowrole}</td>
                                                                    <td>
                                                                        <div className="position-relative">
                                                                            <Form.Select
                                                                                disabled={true}
                                                                                className="common-select contact-dropdown-size m-0"
                                                                                isInvalid={input?.errors?.roleid}
                                                                            >
                                                                                <option value="">Contact</option>
                                                                            </Form.Select>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </>
                                                    ))
                                                ) : (
                                                    <tr className="text-center">
                                                        <td colSpan={6}>
                                                            <Nodata />
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </Container>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="grey-btn w-auto" onClick={props.onHide}>
                        Close
                    </button>
                    <button disabled={Loading} className="blue-btn w-auto" type="submit">
                        {Loading ? <SubmitLoading /> : "Submit"}
                    </button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default WorkFlowPassModal;
